<template>
  <v-card
    class="win-feed-item mr-2 px-4 py-2 d-flex align-center"
    :style="styles"
    flat tile :ripple="false"
    :to="to"
  >
    <div class="overlay d-flex align-center px-1 text-caption justify-center">
      <div v-if="gameName" class="d-flex align-center of-hidden">
        <v-img :src="gameIcon" contain width="40" class="mr-3" />
        <div class="of-hidden">
          <div class="font-weight-bold green400--text text-truncate" v-text="gameName" />
          <span v-t="`common.games.${item.game}`" />
        </div>
      </div>
      <span v-else v-t="`common.games.${item.game}`" />
    </div>

    <div class="game-icon pos-relative mr-3">
      <v-img :src="icon" width="40" />
    </div>

    <div class="pos-relative of-hidden z-1">
      <div class="text-body-2 mb-1 text--secondary">
        <span v-if="!isScrapWin" class="font-weight-semibold">
          ${{ item.won | toScrap }}
        </span>
        <scrap v-else :amount="item.won" />
      </div>

      <div class="of-hidden user text-caption text-truncate text--secondary d-flex align-center">
        <Username :user="item.user" />
      </div>
    </div>
  </v-card>
</template>

<script>
const casesImg = require('@/assets/img/games/cases/icon.png')
const wheelImg = require('@/assets/img/games/wheel/icon.png')
const coinflipImg = require('@/assets/img/games/coinflip/icon.png')
const spinnersImg = require('@/assets/img/games/spinners/icon.png')
const diceImg = require('@/assets/img/games/dice/icon.png')
const caseBattlesImg = require('@/assets/img/games/case-battles/icon.png')

const SCRAP_GAMES = ['wheel', 'spinners', 'cases', 'dice', 'caseBattles']
const GAME_COLORS = {
  wheel: '#cd412b',
  cases: '#aade4e',
  spinners: '#3f99d7',
  coinflip: '#f1c40f',
  dice: '#ffb8b8',
  caseBattles: '#e67e22',
}

const GAME_ICONS = {
  cases: casesImg,
  wheel: wheelImg,
  coinflip: coinflipImg,
  spinners: spinnersImg,
  dice: diceImg,
  caseBattles: caseBattlesImg,
}

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isScrapWin() {
      return SCRAP_GAMES.includes(this.item.game)
    },
    styles() {
      return {
        '--color': GAME_COLORS[this.item.game],
      }
    },
    gameInfo() {
      return this.item.gameInfo
    },
    gameItem() {
      return this.gameInfo?.item
    },
    gameName() {
      return this.gameInfo?.name
    },
    icon() {
      if (this.gameItem?.image) {
        return `https://community.cloudflare.steamstatic.com/economy/image/${this.gameItem.image}/164x164`
      }

      return this.gameIcon
    },
    gameIcon() {
      if (this.gameInfo?.imageUrl) {
        return this.gameInfo?.imageUrl
      }

      return GAME_ICONS[this.item.game]
    },
    to() {
      switch (this.item.game) {
        case 'wheel':
          return { name: 'Wheel' }
        case 'coinflip':
          return { name: 'Coinflip' }
        case 'spinners':
          return { name: 'Spinners' }
        case 'dice':
          return { name: 'Beancan Blast' }
        case 'cases':
          return { name: 'Case', params: { slug: this.gameInfo.slug } }
        case 'caseBattles':
          return { name: 'Crate Battle', params: { id: this.gameInfo?.gameId } }
        default:
          break
      }

      return null
    },
  },
}
</script>

<style lang="scss" scoped>
.win-feed-item {
  position: relative;
  min-width: 175px !important;
  background-color: rgba(#615e58, 0.75) !important;
  cursor: pointer;

  .overlay {
    @include overlay;

    overflow: hidden;
    z-index: 3;
    opacity: 0;
    background: rgba(grey(900), 0.8);
    transition: opacity 0.4s ease;
  }

  &:hover {
    .overlay {
      opacity: 1;
    }
  }

  &::before {
    @include overlay;

    opacity: 0.3;
    background: radial-gradient(circle at left center, var(--color), transparent);
    content: ' ';
    pointer-events: none;
  }
}
</style>
